export default __webpack_public_path__ + "static/media/clock.f7a21c58.svg";